import { SettingsView } from "../ws7/settings/SettingsView";
import "../ws7/ws7.css";

/** /settings?tab=artists|lexicon|accounts|tokens|settings|sources (WS7). */
export function SettingsPage() {
  return <SettingsView />;
}
